import { CommonErrorCodesLookup } from '~/common/helpers';
import { useErrorTranslation } from '~/common/hooks';

export const useCommonErrorTranslation = () =>
  useErrorTranslation(CommonErrorCodesLookup);
